/**
 * Returns the concatenation of url and path as a valid URL
 *
 * @param url
 * @param path
 * @returns
 */
export function addPathToBaseUrl(url: string, path: string) {
  let _url = url.trim();
  _url = _url.endsWith("/") ? _url : _url + "/";

  let _path = path.trim();
  _path = _path.startsWith("/") ? _path.slice(1) : _path;

  return _url + _path;
}

/**
 * Returns prettier byte strins
 *
 * @param x
 * @returns
 */
export function niceBytes(x: number) {
  const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let l = 0;
  while (x >= 1024 && ++l) {
    x = x / 1024;
  }
  return x.toFixed(x < 10 && l > 0 ? 1 : 0) + " " + units[l];
}
/**
 * Return the concatenation of base url, resource path and optional resource id.
 *
 * @param base Base URL
 * @param resource The path to the resource
 * @param id Optional resource ID
 * @returns
 */
export function resourceUrl(base: string, resource: string, id?: string) {
  if (id) return addPathToBaseUrl(base, addPathToBaseUrl(resource, id));
  return addPathToBaseUrl(base, resource);
}
